import React from 'react';

function SVG( props ){

  return (
    <svg width='40px'
      height='38px'
      role='img'
      { ...props }
      viewBox='0 0 40 38'
      version='1.1'
    >
      <title>F2FC3F8D-6F01-49C6-87FF-35131BE2843F</title>
      <g
        id='------I.-CART-/-Guest-(Ship)'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <g id='1.A-XL_Empty-Bag-'
          transform='translate(-695.000000, -569.000000)'
          fill='#000000'
          fillRule='nonzero'
        >
          <g id='Sign-In-/-Create-Account'
            transform='translate(40.000000, 404.000000)'
          >
            <g id='Create-Account'
              transform='translate(451.000000, 48.000000)'
            >
              <g id='Icons'
                transform='translate(48.000000, 115.583333)'
              >
                <g id='2'
                  transform='translate(123.000000, 0.416667)'
                >
                  <g id='Base/Icons/UI/fast-checkout'
                    transform='translate(33.000000, 1.666667)'
                  >
                    <path
                      d='M21.8795397,34.0649827 C22.602124,34.071953 23.1833331,34.6626904 23.1781321,35.3841219 C23.1728609,36.0410776 22.6824111,36.5795373 22.0505862,36.6666667 L22.0505862,36.6666667 L6.16594841,36.6666667 C5.53412346,36.5795373 5.04541908,36.0410776 5.04012072,35.3841219 C5.03320147,34.6626904 5.61441061,34.071953 6.33699494,34.0649827 L6.33699494,34.0649827 Z M22.5462721,0 C26.5117591,0 29.7267357,3.21333238 29.7267357,7.17597763 C29.7267357,7.63427829 29.6831014,8.08735119 29.5975782,8.52996855 L38.7241325,8.52822597 L38.9021605,8.54042408 C39.4833697,8.62232572 39.9458934,9.09456709 40,9.69575997 L37.4377927,35.203764 L37.4430289,35.3745376 C37.4133575,36.0471766 36.8565836,36.5943493 36.1636706,36.5943493 L27.719557,36.6657954 L27.5258206,36.6535973 C26.8922503,36.5664679 26.4035459,36.0280081 26.3983098,35.3710524 C26.3913283,34.649621 26.9725375,34.0588836 27.6951218,34.0519133 L34.765627,34.0379726 L37.3383065,11.0863452 L7.75423765,11.0863452 L8.39653484,16.6591419 L8.40177096,16.8525691 C8.37559037,17.4903564 7.88514061,18.0270735 7.23237119,18.096777 C6.5132776,18.1734509 5.86923504,17.652417 5.79243863,16.9344708 L5.39798438,12.7400613 L5.09254414,9.69575997 L5.12047011,9.51975857 C5.25137307,8.9464471 5.76451267,8.52822597 6.36841165,8.52822597 L15.4932206,8.52996855 C15.4076973,8.08735119 15.3658084,7.63427829 15.3658084,7.17597763 C15.3658084,3.21333238 18.5807851,0 22.5462721,0 Z M18.5865448,27.5890027 C19.3091292,27.595973 19.8903383,28.1867104 19.8851373,28.9081418 C19.8781207,29.563355 19.3894163,30.1035573 18.7575913,30.1906867 L18.7575913,30.1906867 L1.1258354,30.1906867 C0.495755818,30.1035573 0.00705143621,29.563355 3.47374967e-05,28.9081418 C-0.00516617334,28.1867104 0.574297594,27.595973 1.2986273,27.5890027 L1.2986273,27.5890027 Z M21.8795397,21.1130227 C22.602124,21.119993 23.1833331,21.7107304 23.1781321,22.4321618 C23.1732123,23.0436941 22.7456481,23.5550391 22.1749643,23.69134 L22.0505862,23.7147067 L6.16594841,23.7147067 C5.53412346,23.6275772 5.04541908,23.0873749 5.04012072,22.4321618 C5.03363392,21.7558198 5.54405684,21.1943457 6.20327619,21.12106 L6.33699494,21.1130227 L21.8795397,21.1130227 Z M22.5462721,2.55986186 C19.994537,2.55986186 17.9262703,4.6265713 17.9262703,7.17597763 C17.9262703,7.64124864 17.9943398,8.09606413 18.1269882,8.52996855 L26.9638106,8.52996855 C27.0982043,8.09606413 27.1662739,7.64124864 27.1662739,7.17597763 C27.1662739,4.6265713 25.0980071,2.55986186 22.5462721,2.55986186 Z'
                      id='Icon-Color'
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SVG;
